import Header from "./Header";

const Layout = ({ children }) => (
  <>
    <a className="skip-link" href="#main-content">Перейти к содержимому</a>
    <Header />
    <div className="page-content">
      <main id="main-content">{children}</main>
      <footer className="site-footer">© {new Date().getFullYear()} Дарья Немкович</footer>
    </div>
  </>
);

export default Layout;
